module.exports = __webpack_public_path__ + "img/ucf1g-03.prt.2c950f6d.jpg";